import { render } from "./PostModal.vue?vue&type=template&id=3aee344e&scoped=true"
import script from "./PostModal.vue?vue&type=script&lang=js"
export * from "./PostModal.vue?vue&type=script&lang=js"

import "./PostModal.vue?vue&type=style&index=0&id=3aee344e&lang=scss&scoped=true"

import exportComponent from "/Users/nisalatp/Projects/Herd/OrangeHRM/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aee344e"]])

export default __exports__